import React, { useState } from 'react';
import { StepperPage } from '../../Stepper';
import Kyb from '../Kyb';
import { OrgNode } from '../../../services/orgs/interfaces';
import { FieldError } from '../../VgsInput/field';

export const useKybStep = ({
  form,
  ...props
}: {
  org?: OrgNode;
  onBusinessTypeChange: (type: string) => void;
  onBusinessStructureChange: (type: string) => void;
  onAddressRegionChange: (region: string) => void;
  form?: VGSForm<{
    vaultCreateKybKycSubmit: VaultFormMutationResponse;
  }>;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  fieldErrors: FieldError[];
  token: string;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  disabled: boolean;
}): StepperPage | null => {
  const [kybIsValid, setKybIsValid] = useState(false);

  if (!form) {
    return null;
  }
  const kybStep = {
    component: <Kyb onValidChange={setKybIsValid} form={form} {...props} />,
    isValid: kybIsValid,
    navigation: {
      showBack: false,
      showForward: true,
      showSteps: true,
    },
    srName: 'Create KYB',
    shouldRender: true,
  };
  return kybStep;
};
